import React, { useEffect } from "react";
import { useNavContext } from "../../context-api/nav-context";
import QuestEight from "../../components/quote-components/quoteQuestions/QuestEight";

const QuestionEight = () => {
  const { closeNavbarMenu } = useNavContext();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main onMouseOver={closeNavbarMenu}>
      <QuestEight />
    </main>
  );
};

export default QuestionEight;
